import { createSelector } from 'reselect';

const getCompanies = state => state.forexCompanies;

export const getCompaniesIsFetching = createSelector(
  getCompanies,
  companies => companies.isFetching
);

export const getCompaniesIsLoaded = createSelector(
  getCompanies,
  companies => companies.isLoaded
);

export const getCompaniesIds = createSelector(
  getCompanies,
  companies => companies.ids
);

export const getCompaniesEntities = createSelector(
  getCompanies,
  companies => companies.entities
);

export const getCompaniesItems = createSelector(
  getCompaniesIds,
  getCompaniesEntities,
  (ids, entities) => ids.map(id => entities[id])
);

export const makeCompaniesItems = () => getCompaniesItems;
